import { Track } from "@/modules/property-tracks/types";
import { Breadcrumbs, Typography, useTheme } from "@mui/material";
export default function PropertyTrackTitle(track: {
  track: Track | undefined;
}) {
  const theme = useTheme();
  return (
    <Breadcrumbs
      separator="•"
      sx={{
        ...theme.nawy.typography.english.variants.headline.sm,
        color: theme.nawy.colors.semantic.text.primary,
      }}
    >
      <Typography sx={theme.nawy.typography.english.variants.headline.sm}>
        {track.track?.trackStage?.trackType?.name}
      </Typography>
      {track.track?.property.propertyType && (
        <Typography sx={theme.nawy.typography.english.variants.headline.sm}>
          {track.track?.property.propertyType.name}
        </Typography>
      )}
      {track.track?.property.compound && (
        <Typography sx={theme.nawy.typography.english.variants.headline.sm}>
          {track.track?.property.compound.name}
        </Typography>
      )}
    </Breadcrumbs>
  );
}
